import { Routes } from "./enums";

export const getUrlToRedirect = (): string => {
  const { href } = window.location;
  let encodedHref = "";

  if (href.includes(Routes.ACCEPT_INVITE)) {
    try {
      encodedHref = encodeURIComponent(href);
    } catch {
      encodedHref = "";
    }
  }

  const urlToRedirect = encodedHref ? `?continue=${encodedHref}` : "";

  return urlToRedirect;
};
